import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState } from 'react';

import { SnackbarOpen } from '#app/Action/SnackbarAction';
import { dispatch } from '#app/App';
import ButtonComponent from '#app/Component/ButtonComponent';
import ApiHandler from '#app/Handler/ApiHandler';
import useUserPreparers from '#app/View/InventoryManagement/PreparerManager/hooks/useUserPreparers';
import { UserPreparer } from '#app/typings/userPreparer';

type Props = {
  onClose: () => void;
  preparer: UserPreparer;
};

const DisabledPreparerModal: React.FC<Props> = ({ onClose, preparer }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState<boolean>(false);
  const { mutate } = useUserPreparers();

  const handleSubmit = () => {
    setLoading(true);
    ApiHandler.post(
      {
        route: 'api_inventory_management_preparer_manager_preparer_activity_inactive',
        data: {},
        params: { id: preparer.id },
      },
      (response) => {
        if (response.status === 200) {
          dispatch(
            SnackbarOpen({
              text: 'Modification enregistrée avec succès.',
              variant: 'success',
            }),
          );
          onClose();
          mutate();
        } else {
          dispatch(
            SnackbarOpen({
              text: response?.error?.message || "Une erreur inattendue s'est produite.",
              variant: 'error',
            }),
          );
        }
        setLoading(false);
      },
    );
  };

  return (
    <Dialog open maxWidth="xl" onClose={onClose}>
      <DialogTitle>{preparer.name}</DialogTitle>
      <DialogContent className={classes.content}></DialogContent>
      <DialogActions>
        <ButtonComponent color="#5E6E82" label="Annuler" onClick={onClose} disabled={loading} />
        <ButtonComponent label="Désactiver" onClick={handleSubmit} loading={loading} />
      </DialogActions>
    </Dialog>
  );
};

const useStyles = makeStyles({
  content: {
    minWidth: 400,
  },
});

export default DisabledPreparerModal;
